// Helper utilities for AWS Amplify API v6
// Provides backward-compatible wrappers for the old API.get/post/put/del syntax

import { get as amplifyGet, post as amplifyPost, put as amplifyPut, del as amplifyDel } from 'aws-amplify/api'

/**
 * GET request wrapper
 * @param {string} apiName - The name of the API endpoint
 * @param {string} path - The path to call
 * @param {object} init - Optional parameters (queryStringParameters, headers, etc.)
 * @returns {Promise} - Resolves to the response data
 */
export async function apiGet(apiName, path, init = {}) {
  const options = {}
  
  if (init.queryStringParameters) {
    options.queryParams = init.queryStringParameters
  }
  
  if (init.headers) {
    options.headers = init.headers
  }

  const response = await amplifyGet({ apiName, path, options }).response
  const data = await response.body.json()
  return data
}

/**
 * POST request wrapper
 * @param {string} apiName - The name of the API endpoint
 * @param {string} path - The path to call
 * @param {object} init - Optional parameters (body, headers, etc.)
 * @returns {Promise} - Resolves to the response data
 */
export async function apiPost(apiName, path, init = {}) {
  const options = {}
  
  if (init.body) {
    options.body = init.body
  }
  
  if (init.headers) {
    options.headers = init.headers
  }

  const response = await amplifyPost({ apiName, path, options }).response
  const data = await response.body.json()
  return data
}

/**
 * PUT request wrapper
 * @param {string} apiName - The name of the API endpoint
 * @param {string} path - The path to call
 * @param {object} init - Optional parameters (body, headers, etc.)
 * @returns {Promise} - Resolves to the response data
 */
export async function apiPut(apiName, path, init = {}) {
  const options = {}
  
  if (init.body) {
    options.body = init.body
  }
  
  if (init.headers) {
    options.headers = init.headers
  }

  const response = await amplifyPut({ apiName, path, options }).response
  const data = await response.body.json()
  return data
}

/**
 * DELETE request wrapper
 * @param {string} apiName - The name of the API endpoint
 * @param {string} path - The path to call
 * @param {object} init - Optional parameters (headers, etc.)
 * @returns {Promise} - Resolves to the response data
 */
export async function apiDel(apiName, path, init = {}) {
  const options = {}
  
  if (init.headers) {
    options.headers = init.headers
  }

  const response = await amplifyDel({ apiName, path, options }).response
  const data = await response.body.json()
  return data
}

// Export as API object for easier migration
export const API = {
  get: apiGet,
  post: apiPost,
  put: apiPut,
  del: apiDel
}
